import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DragDropContext, Draggable } from "@hello-pangea/dnd";
import { StrictModeDroppable as Droppable } from "../../helpers/StrictModeDroppable";
import axios from '../../api/axios';
import _ from "lodash";
import styles from './Admin.module.css';
import LoadingModal from "../LoadingModal";
import { Link } from "react-router-dom";


const defaultStatements = [
	{
		displayOrder: 1,
		text: "Statement 1"
	},
	{
		displayOrder: 2,
		text: "Statement 2"
	}
]

const validTextRegex = /(.|\s)*\S(.|\s)*/

const EditConstantSumQuestion = () => {

	const navigate = useNavigate();

	let { questionId } = useParams();

	const [text, setText] = useState("");
	const [shuffleStatements, setShuffleStatements] = useState(false);
	const [status, setStatus] = useState("active");
	const [statements, setStatements] = useState([...defaultStatements]);
	const [total, setTotal] = useState(100);
	const [statementMaximum, setStatementMaximum] = useState(100);
	const [feature, setFeature] = useState(true);
	const [priority, setPriority] = useState(1);
	const [constantSum, setConstantSum] = useState(true);
	const [useSliders, setUseSliders] = useState(true);
	const [numberType, setNumberType] = useState("number");
	const [chartType, setChartType] = useState("table");

	const [textCopy, setTextCopy] = useState("");
	const [shuffleStatementsCopy, setShuffleStatementsCopy] = useState(false);
	const [statusCopy, setStatusCopy] = useState("active");
	const [statementsCopy, setStatementsCopy] = useState([...defaultStatements]);
	const [totalCopy, setTotalCopy] = useState(0);
	const [statementMaximumCopy, setStatementMaximumCopy] = useState(0);
	const [featureCopy, setFeatureCopy] = useState(true);
	const [priorityCopy, setPriorityCopy] = useState(1);
	const [constantSumCopy, setConstantSumCopy] = useState(true);
	const [useSlidersCopy, setUseSlidersCopy] = useState(true);
	const [numberTypeCopy, setNumberTypeCopy] = useState("number");
	const [chartTypeCopy, setChartTypeCopy] = useState("table");

	const [activeStatements, setActiveStatements] = useState(0);

	const [validStatements, setValidStatements] = useState(0);
	const [validQuestion, setValidQuestion] = useState(false);
	const [validLimits, setValidLimits] = useState(false);

	const [isSaving, setIsSaving] = useState(false);
	const [dataLoaded, setDataLoaded] = useState(questionId ? false : true);

	// const axiosPrivate = useAxiosPrivate();
	// const navigate = useNavigate();
	// const location = useLocation();

	const parseResponse = (response) => {
		if (response && response.data) {

			console.log(JSON.stringify(response.data));

			setText(response.data.text);
			setShuffleStatements(response.data.shuffleStatements);
			setStatus(response.data.status);
			setStatements(_.cloneDeep(response.data.statements));
			setTotal(response.data.total);
			setStatementMaximum(response.data.statementMaximum);
			setFeature(response.data.feature);
			setPriority(response.data.priority);
			setConstantSum(response.data.constantSum);
			setUseSliders(response.data.useSliders);
			setNumberType(response.data.numberType);
			setChartType(response.data.chartType);

			setTextCopy(response.data.text);
			setShuffleStatementsCopy(response.data.shuffleStatements);
			setStatusCopy(response.data.status);
			setStatementsCopy(_.cloneDeep(response.data.statements));
			setTotalCopy(response.data.total);
			setStatementMaximumCopy(response.data.statementMaximum);
			setFeatureCopy(response.data.feature);
			setPriorityCopy(response.data.priority);
			setConstantSumCopy(response.data.constantSum);
			setUseSlidersCopy(response.data.useSliders);
			setNumberTypeCopy(response.data.numberType);
			setChartTypeCopy(response.data.chartType);

			setIsSaving(false);
			setDataLoaded(true);
		} else {
			console.log("Error: response is not valid");
		}

	}

	const onNumericInput = event => {
		const input = event.target.value.replace(/\D/g, '');
		let value = parseInt(input, 10);
		if (isNaN(value)) {
			value = "";
		}
		const name = event.target.name;
		switch (name) {
			case "total":
				setTotal(value);
				break;
			case "statementMaximum":
				setStatementMaximum(value);
				break;
			default:
				console.log(`Error - unrecognized input. name: ${name} value: ${value}`);
		}
	};

	const onStatementChange = (index, text) => {
		setStatements(prev => prev.with(index, { ...prev[index], text: text }));
	}
	const onDeleteStatement = (index) => {
		// if this hasn't been saved to the databse (constantSumStatementId is undefined), and no text has been set, delete it altogether
		if ((statements[index].constantSumStatementId === undefined) && (statements[index].text === "")) {
			setStatements(prev => prev.toSpliced(index, 1));
		} else {
			const deleted = (statements[index].deleted === true ? false : true);
			setStatements(prev => prev.with(index, { ...prev[index], deleted: deleted }));
		}
	}
	const onAddStatement = () => {

		const newStatements = _.cloneDeep(statements);

		let
			max,
			i, l;

		max = 0;

		for (i = 0, l = newStatements.length; i < l; i++) {
			max = Math.max(max, newStatements[i].displayOrder);
		}

		newStatements.push({
			displayOrder: max + 1,
			text: ""
		})

		setStatements(newStatements);
	}

	const handleStatementOnDragEnd = (result) => {
		if (!result?.destination) return;

		const newStatements = _.cloneDeep(statements);

		const [reorderedStatement] = newStatements.splice(result.source.index, 1);

		newStatements.splice(result.destination.index, 0, reorderedStatement);

		console.log(newStatements);

		setStatements(newStatements);

	}

	const saveChanges = () => {
		if (questionId === undefined) {
			saveNewConstantSum();
		} else {
			saveUpdatedConstantSum();
		}
	}

	const saveUpdatedConstantSum = async () => {
		if (!validQuestion || (validStatements < 2)) {
			return;
		}

		let
			displayOrder;

		const statementsToDelete = [];
		const statementsToUpdate = [];
		const statementsToInsert = [];

		displayOrder = 0;

		for (let statement of statements) {
			if ((statement.deleted === true) && (statement.constantSumStatementId !== undefined)) {
				statementsToDelete.push({ constantSumStatementId: statement.constantSumStatementId });
			} else {
				displayOrder++;
				statement.displayOrder = displayOrder;
				if (statement.constantSumStatementId === undefined) {
					statementsToInsert.push(statement);
				} else {
					for (let copy of statementsCopy) {
						if (statement.constantSumStatementId === copy.constantSumStatementId) {
							if ((statement.displayOrder !== copy.displayOrder) || (statement.text !== copy.text)) {
								statementsToUpdate.push(statement);
							}
						}
					}
				}
			}
		};

		const json = {};

		json.text = text;
		json.shuffleStatements = shuffleStatements;
		json.status = status;
		json.total = total;
		json.feature = feature;
		json.priority = priority;
		json.statementMaximum = statementMaximum;
		json.constantSum = constantSum;
		json.useSliders = useSliders;
		json.numberType = numberType;
		json.chartType = chartType;
		json.statementsToDelete = _.cloneDeep(statementsToDelete);
		json.statementsToUpdate = _.cloneDeep(statementsToUpdate);
		json.statementsToInsert = _.cloneDeep(statementsToInsert);

		if (
			(text !== textCopy) ||
			(shuffleStatements !== shuffleStatementsCopy) ||
			(status !== statusCopy) ||
			(total !== totalCopy) ||
			(statementMaximum !== statementMaximumCopy) ||
			(feature !== featureCopy) ||
			(priority !== priorityCopy) ||
			(constantSum !== constantSumCopy) ||
			(numberType !== numberTypeCopy) ||
			(chartType !== chartTypeCopy) ||
			(useSliders !== useSlidersCopy) ||
			(statementsToDelete.length > 0) ||
			(statementsToUpdate.length > 0) ||
			(statementsToInsert.length > 0)
		) {
			setIsSaving(true);
			try {
				const response = await axios.patch(`/constantSumQuestions/${questionId}`,
					JSON.stringify(json),
					{
						headers: { 'Content-Type': 'application/json' }
					}
				);

				parseResponse(response);

			} catch (err) {
				console.log(err);
				// if (!err?.response) {
				//     setErrMsg('No Server Response');
				// } else if (err.response?.status === 409) {
				//     setErrMsg('Email Taken');
				// } else {
				//     setErrMsg('Registration Failed')
				// }
				// errRef.current.focus();
			}

		}

	}
	const saveNewConstantSum = async () => {
		if (!validQuestion || (validStatements < 2)) {
			return;
		}

		let
			displayOrder;

		const statementsToInsert = [];

		displayOrder = 0;

		for (let statement of statements) {
			displayOrder++;
			statement.displayOrder = displayOrder;
			statementsToInsert.push({
				displayOrder: displayOrder,
				text: statement.text
			});
		};

		const json = {};

		json.text = text;
		json.shuffleStatements = shuffleStatements;
		json.status = status;
		json.total = total;
		json.statementMaximum = statementMaximum;
		json.feature = feature;
		json.priority = priority;
		json.constantSum = constantSum;
		json.useSliders = useSliders;
		json.numberType = numberType;
		json.chartType = chartType;
		json.statements = _.cloneDeep(statementsToInsert);

		if (statementsToInsert.length >= 2) {
			setIsSaving(true);
			try {
				const response = await axios.post(`/constantSumQuestions`,
					JSON.stringify(json),
					{
						headers: { 'Content-Type': 'application/json' }
					}
				);

				console.log(JSON.stringify(response?.data));

				questionId = response.data.questionId;

				parseResponse(response);

				navigate(`/constantsumquestion/edit/${questionId}`, { replace: true });

			} catch (err) {
				console.log(err);
				// if (!err?.response) {
				//     setErrMsg('No Server Response');
				// } else if (err.response?.status === 409) {
				//     setErrMsg('Email Taken');
				// } else {
				//     setErrMsg('Registration Failed')
				// }
				// errRef.current.focus();
			}

		}

	}

	useEffect(() => {

		if (questionId === undefined) {
			return;
		}

		let isMounted = true;

		const controller = new AbortController();

		const getConstantSum = async () => {

			setIsSaving(true);

			try {
				console.log(`questionId: ${questionId}`);
				const response = await axios.get(`/constantSumQuestions/${questionId}`, {
					signal: controller.signal
				});
				console.log(response.data);
				if (isMounted) {
					parseResponse(response);
				}
			} catch (err) {
				if (isMounted) {
					console.error(err);
					// if (err.response?.status === 403) {
					//     navigate('/login', { state: { from: location }, replace: true });
					// }
				}
			}
		}

		getConstantSum();

		return () => {
			isMounted = false;
			controller.abort();
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		let i, l, active, valid;

		active = 0;
		valid = 0;

		for (i = 0, l = statements.length; i < l; i++) {
			if (statements[i].deleted !== true) {
				active++;
				if (validTextRegex.test(statements[i].text)) {
					valid++;
				}
			}
		}
		setActiveStatements(active);
		setValidStatements(valid);

	}, [statements]);

	useEffect(() => {
		setValidQuestion(validTextRegex.test(text));
	}, [text]);

	useEffect(() => {
		let valid = true;
		if (isNaN(total) || (total < 10) || (total > 999)) {
			valid = false;
		}
		if (isNaN(statementMaximum) || (statementMaximum < 3) || (statementMaximum > 999)) {
			valid = false;
		}
		setValidLimits(valid);
	}, [total, totalCopy, statementMaximum, statementMaximumCopy]);

	if (!dataLoaded) {
		return <LoadingModal />;
	}

	console.log(`EditConstantSumQuestion: render at ${new Date().getTime()}`);

	return (
		<section className={styles.admin}>
			<p><Link to="/admin">Admin</Link> &gt; <Link to="/questions">Questions</Link></p>
			<h3 className={styles.noBorder}>{(questionId === undefined) ? "New constant" : "Constant"} sum question</h3>

			<input type="text" name="question" autoComplete="off" autoFocus={true} maxLength="500" placeholder="Who is your favorite Red Sox player?" value={text} onChange={e => setText(e.target.value)} />

			<h3>Status:</h3>

			<div className="radio-button-and-label">
				<input type="radio" id="active" name="status" value="active" onChange={(e) => setStatus(e.target.value)} checked={status === "active"} />
				<label htmlFor="active">Active</label>
			</div>

			<div className="radio-button-and-label">
				<input type="radio" id="archived" name="status" value="archived" onChange={(e) => setStatus(e.target.value)} checked={status === "archived"} />
				<label htmlFor="archived">Archived</label>
			</div>

			<div className="radio-button-and-label">
				<input type="radio" id="deleted" name="status" value="deleted" onChange={(e) => setStatus(e.target.value)} checked={status === "deleted"} />
				<label htmlFor="deleted">Deleted</label>
			</div>

			<h3>Chart type:</h3>

			<div className="radio-button-and-label">
				<input type="radio" id="table" name="chartType" value="table" onChange={(e) => setChartType(e.target.value)} checked={chartType === "table"} />
				<label htmlFor="table">Table</label>
			</div>

			<div className="radio-button-and-label">
				<input type="radio" id="columnChart" name="chartType" value="column chart" onChange={(e) => setChartType(e.target.value)} checked={chartType === "column chart"} />
				<label htmlFor="columnChart">Column chart</label>
			</div>

			<h3>Type:</h3>

			<div className="radio-button-and-label">
				<input type="radio" id="number" name="type" value="number" onChange={(e) => setNumberType(e.target.value)} checked={numberType === "number"} />
				<label htmlFor="number">Number</label>
			</div>

			<div className="radio-button-and-label">
				<input type="radio" id="currency" name="type" value="currency" onChange={(e) => setNumberType(e.target.value)} checked={numberType === "currency"} />
				<label htmlFor="currency">Currency</label>
			</div>

			<div className="radio-button-and-label">
				<input type="radio" id="percent" name="type" value="percent" onChange={(e) => setNumberType(e.target.value)} checked={numberType === "percent"} />
				<label htmlFor="percent">Percent</label>
			</div>

			<div className="label-and-numeric-input">
				<label htmlFor="statementMaximum">Individual statement max:</label>
				<input type="text" style={{ fontSize: '1rem' }} className={`${numberType}`} id="statementMaximum" name="statementMaximum" autoComplete="off" maxLength="3" placeholder="100" size="5" value={statementMaximum} onChange={onNumericInput} />
				<label className="note">(1 &ndash; 999)</label>
			</div>

			<div className="label-and-numeric-input">
				<label htmlFor="total">Total (sum) of all statements:</label>
				<input type="text" style={{ fontSize: '1rem' }} className={`${numberType}`} id="total" name="total" autoComplete="off" maxLength="3" placeholder="100" size="5" value={total} onChange={onNumericInput} />
				<label className="note">(1 &ndash; 999)</label>
			</div>

			{/* <label style={{ marginTop: '2rem' }} htmlFor="priority">Priority (5: highest, 1: lowest)</label>
            <select name="priority" value={priority} onChange={(e) => setPriority(parseInt(e.target.value, 10))}>
                <option value="5">5 (Highest)</option>
                <option value="4">4 (High)</option>
                <option value="3">3 (Moderate)</option>
                <option value="2">2 (Low)</option>
                <option value="1">1 (Lowest)</option>
            </select> */}

			<div className="checkbox-and-label" style={{ marginTop: '2rem' }}>
				<input type="checkbox" id="constantSum" name="constantSum" onChange={(e) => setConstantSum(e.target.checked)} checked={constantSum} />
				<label htmlFor="constantSum">Statements must sum to total</label>
			</div>

			<div className="checkbox-and-label" style={{ marginTop: '0.5rem' }}>
				<input type="checkbox" id="useSliders" name="useSliders" onChange={(e) => setUseSliders(e.target.checked)} checked={useSliders} />
				<label htmlFor="useSliders">Use sliders</label>
			</div>

			{/* <div className="checkbox-and-label" style={{ marginTop: '0.5rem' }}>
                <input type="checkbox" id="feature" name="feature" onChange={(e) => setFeature(e.target.checked)} checked={feature} />
                <label htmlFor="feature">Feature this question on a dashboard</label>
            </div> */}

			<h3 className={styles.noBorder}>Constant sum statements (rows):</h3>

			<div className="dndContainer">
				<DragDropContext onDragEnd={handleStatementOnDragEnd}>
					<Droppable droppableId="statements">
						{(provided) => (
							<div className="optionsGroup" {...provided.droppableProps} ref={provided.innerRef}>
								{
									statements.map((statement, i) => {
										return (
											<Draggable key={i} draggableId={i.toString()} index={i}>
												{(provided) => (
													<div className="optionGroup" {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
														<input key={i} type="text" autoComplete="off" maxLength="500" placeholder={`Statement ${i + 1}`} disabled={statement.deleted} value={statement.text} onChange={e => onStatementChange(i, e.target.value)} />
														<button className="delete" onClick={e => onDeleteStatement(i)}></button>
													</div>
												)}
											</Draggable>
										)
									})
								}
								{provided.placeholder}
							</div>
						)}
					</Droppable>
				</DragDropContext>
				<button onClick={e => onAddStatement()} disabled={activeStatements >= 10} >Add new statement (row)</button>
			</div>
			<div className="checkbox-and-label">
				<input type="checkbox" id="shuffleCheckbox" name="shuffleCheckbox" onChange={(e) => setShuffleStatements(e.target.checked)} checked={shuffleStatements} />
				<label htmlFor="shuffleCheckbox">Randomize (shuffle) the order of statements</label>
			</div>

			<button disabled={!validQuestion || (validStatements < 2) || isSaving || !validLimits} onClick={saveChanges}>Save changes</button>

		</section>
	);

};

export default EditConstantSumQuestion;